import { AppThunk } from "../../store";
import { serviceActions } from "./serviceSlice";
import { apiFetch } from "../../../utils/api";

export const fetchServices = (): AppThunk => async (dispatch) => {
  try {
    dispatch(serviceActions.startLoading());
    const data = await apiFetch("/api/services");
    dispatch(serviceActions.setServices(data));
  } catch (e: any) {
    dispatch(serviceActions.setError(e.message));
  } finally {
    dispatch(serviceActions.endLoading());
  }
};
